import React, { useState, useEffect } from "react";
import RouteMap from "../routeMap/routeMap";
import RouteTable from "../routeTable/routeTable";
import ServiceAlert from "./serviceAlert";
import {StopData} from "../../../interfaces/routes/routeData";

function ScheduleTable({ scheduleData }: any) {
	const [routeData, updateRouteData] = useState(scheduleData);
	const [day, updateDay] = useState(scheduleData.Weekday ? 'Weekday' : scheduleData.Saturday ? 'Saturday' : 'Sunday');
	const [direction, updateDirection] = useState(scheduleData.Directions[0]);
	const [activeSchedule, updateActiveSchedule] = useState<any>(null);
	const [customSchedule, updateCustomSchedule] = useState(scheduleData.CustomSchedules);
	const [serviceAlerts, updateServiceAlerts] = useState(scheduleData.ServiceAlerts);
	const [tableStatus, updateTableStatus] = useState(true);
	const [stopDetails, updateStopDetails] = useState<StopData>({
		id: '',
		lat: 0,
		lng: 0,
	});

	const onRadioChange = (e: React.SyntheticEvent) => {
		const target = e.target as HTMLInputElement;
		const name = target.name;
		const value = target.value;
		if (name === 'day') {
			updateDay(value);
		}
		if (name === 'direction') {
			updateDirection(value);
		}
	}

	const updateSelectedStop = (data: StopData) => {
		updateStopDetails(data);
	}

	useEffect(() => {
		const schedule = routeData.Schedules.filter((item: any) => item.Day === day && item.Direction === direction);
		updateActiveSchedule(schedule[0]);
	},[day, direction]);

	useEffect(() => {
		updateRouteData(scheduleData);
		updateDirection(scheduleData.Directions[0]);
		updateActiveSchedule(scheduleData.Schedules[0]);
		updateCustomSchedule(scheduleData.CustomSchedules);
		updateServiceAlerts(scheduleData.ServiceAlerts);
		if (scheduleData.Weekday) {
			updateDay('Weekday');
		}
		else if (scheduleData.Monday) {
			updateDay('Monday');
		}
		else if (scheduleData.Tuesday) {
			updateDay('Tuesday');
		}
		else if (scheduleData.Wednesday) {
			updateDay('Wednesday');
		}
		else if (scheduleData.Thursday) {
			updateDay('Thursday');
		}
		else if (scheduleData.Friday) {
			updateDay('Friday');
		}
		else if (scheduleData.Saturday) {
			updateDay('Saturday');
		}
		else if (scheduleData.Sunday) {
			updateDay('Sunday');
		}

	}, [scheduleData]);

	return (
		
		<div className={`schedule-table ${!activeSchedule ? "schedule-table--secondary" : ""}`}>
			<div className="schedule-table__content">
				<h2 className="schedule-table__title">
					<span className="schedule-table__id">{routeData?.RouteId}</span>
					{routeData?.Title?.replace(new RegExp(`^${routeData?.RouteId}\\s*-?\\s*`, 'i'), '')}
				</h2>
				{
					routeData?.RouteAlert?.HasAlert &&				
					<div className={`schedule-alert schedule-alert--secondary ${routeData.RouteAlert.CssClass}`}>
						<div dangerouslySetInnerHTML={{ __html: routeData.RouteAlert.Content }} />
					</div>
				}
				<div className="schedule-table__control-panel">
				<div className="schedule-table__tab-container">
					{
						!customSchedule &&
						<div className="schedule-table__tabs">
							<fieldset>
								<legend className="visually-hidden">View the route on the selected day</legend>
								{
									routeData.Weekday && 
									<label className="schedule-table__label">
										<input type="radio" onChange={onRadioChange} className="schedule-table__radio" name="day" checked={day === "Weekday"} value="Weekday"/>
										<span className="schedule-table__pseudo-radio">Weekday</span>
									</label>
								}
								{
									routeData.Monday &&
									<label className="schedule-table__label">
										<input type="radio" onChange={onRadioChange} className="schedule-table__radio" name="day" checked={day === "Monday"} value="Monday" />
										<span className="schedule-table__pseudo-radio">Monday</span>
									</label>
								}
								{
									routeData.Tuesday &&
									<label className="schedule-table__label">
										<input type="radio" onChange={onRadioChange} className="schedule-table__radio" name="day" checked={day === "Tuesday"} value="Tuesday" />
										<span className="schedule-table__pseudo-radio">Tuesday</span>
									</label>
								}
								{
									routeData.Wednesday &&
									<label className="schedule-table__label">
										<input type="radio" onChange={onRadioChange} className="schedule-table__radio" name="day" checked={day === "Wednesday"} value="Wednesday" />
										<span className="schedule-table__pseudo-radio">Wednesday</span>
									</label>
								}
								{
									routeData.Thursday &&
									<label className="schedule-table__label">
										<input type="radio" onChange={onRadioChange} className="schedule-table__radio" name="day" checked={day === "Thursday"} value="Thursday" />
										<span className="schedule-table__pseudo-radio">Thursday</span>
									</label>
								}
								{
									routeData.Friday && 
									<label className="schedule-table__label">
										<input type="radio" onChange={onRadioChange} className="schedule-table__radio" name="day" checked={day === "Friday"} value="Friday"/>
										<span className="schedule-table__pseudo-radio">Friday</span>
									</label>
								}
								{
									routeData.Saturday && 
									<label className="schedule-table__label">
										<input type="radio" onChange={onRadioChange} className="schedule-table__radio" name="day" checked={day === "Saturday"} value="Saturday"/>
										<span className="schedule-table__pseudo-radio">Saturday</span>
									</label>
								}
								{
									routeData.Sunday && 
									<label className="schedule-table__label">
										<input type="radio" onChange={onRadioChange} className="schedule-table__radio" name="day" checked={day === "Sunday"} value="Sunday"/>
										<span className="schedule-table__pseudo-radio">Sunday</span>
									</label>
								}
							</fieldset>
						</div>
					}
					<div className="schedule-table__direction-tabs">
						<fieldset>
							<legend className="visually-hidden">Select the route direction</legend>
							{
								routeData.Directions.map((item:any,index:number) => {
									return (
										<label className="schedule-table__label" key={index}>
											<input type="radio" onChange={onRadioChange} className="schedule-table__radio" name="direction" value={item} checked={direction === item} />
											<span className="schedule-table__pseudo-radio">{item}</span>
										</label>
									)
								})
							}
						</fieldset>
					</div>
				</div>
				<div className="schedule-table__controls">
					{
						activeSchedule &&
						<button type="button" className="schedule-table__toggle" onClick={() => updateTableStatus(!tableStatus)}>
							{
								tableStatus
									?
									<>
										<span className="schedule-table__icon icon icon-location"></span>
										Show Map
									</>
									:
									<>
										<span className="schedule-table__icon icon icon-schedule-table"></span>
										Show Table
									</>
							}
						</button>
					}
				</div>
</div>
				<div className="schedule-table__results">
					{
						serviceAlerts &&
						<ServiceAlert alerts={serviceAlerts} direction={direction} updateSelectedStop={updateSelectedStop}></ServiceAlert>
					}

					{
						activeSchedule
						?
						<>
							<span className="visually-hidden" aria-live="polite">showing route table results for {activeSchedule?.ScheduleTitle}</span>
							<h3 className="schedule-table__heading">
								{activeSchedule?.Direction}
								{!customSchedule ? ', ' + activeSchedule?.Day : ''}
							</h3>
							<div className={`schedule-table__table ${tableStatus ? 'active' : ''}`}>
								{
									(activeSchedule) &&
									<RouteTable activeSchedule={activeSchedule} routeId={routeData.RouteId} customSchedule={customSchedule}></RouteTable>
								}
							</div>
						</>
						:
						<>
							<div>
								<h2 className="schedule-table__title schedule-table__title--secondary">Data not found.</h2>
								<p>Issue is under review.</p>
							</div>
						</>
					}
				</div>
			</div>
			<div className={`schedule-table__rail ${!tableStatus ? 'active' : ''}`}>
				{
					(activeSchedule) &&
					<RouteMap activeSchedule={activeSchedule} routeId={routeData.RouteId} stopDetails={stopDetails}></RouteMap>
				}
			</div>
		</div>
	);
}
export default ScheduleTable;
